import React from "react";

// Original ZSTAMP mark: a perforated postage stamp holding a gold "Z" monogram
// with a small cancellation postmark. Pure SVG, no external assets.
export default function Logo({ size = 36, className = "", style = {} }) {
  const gold = "var(--gold, #E3B341)";
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className}
         style={style} aria-label="ZSTAMP" role="img">
      {/* stamp body */}
      <rect x="7" y="7" width="86" height="86" rx="14"
            fill="rgba(227,179,65,0.07)" stroke={gold} strokeWidth="2"
            strokeDasharray="1.5 5" strokeLinecap="round" />
      {/* inner frame */}
      <rect x="17" y="17" width="66" height="66" rx="8"
            fill="none" stroke={gold} strokeWidth="1.4" opacity="0.8" />
      {/* Z monogram */}
      <polyline points="34,36 66,36 34,64 66,64"
                fill="none" stroke={gold} strokeWidth="8"
                strokeLinejoin="round" strokeLinecap="round" />
      {/* cancellation postmark */}
      <circle cx="75" cy="25" r="12" fill="none" stroke={gold} strokeWidth="1.6" opacity="0.9" />
      <line x1="68" y1="25" x2="82" y2="25" stroke={gold} strokeWidth="1.3" opacity="0.9" />
      <line x1="75" y1="18" x2="75" y2="32" stroke={gold} strokeWidth="1.3" opacity="0.9" />
    </svg>
  );
}
